var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner",style:({opacity: _vm.counter ? '1' : '0'})},[_c('div',{staticClass:"spinner-part-1"}),_c('div',{staticClass:"spinner-part-2"})])
}
var staticRenderFns = []

export { render, staticRenderFns }